import api from "./Api";
import {getAllUsersObjectCache} from "./Auth";



export const getAllInvoiceFormalPromoImage = async () => {
    const response = await api.get(`/invoiceFormalPromoImage/invoiceFormalPromoImageAll`);
    return response.data;
};


export const getInvoiceFormalPromoImageInUse = async () => {
    const response = await api.get(`/invoiceFormalPromoImage/invoiceFormalPromoImageByPicStatus/inUse`);

    return response.data;
};

export const getInvoiceFormalPromoImageNotInUse = async () => {
    const response = await api.get(`/invoiceFormalPromoImage/invoiceFormalPromoImageByPicStatus/notInUse`);

    return response.data;
};

export const setInvoiceFormalPromoImageInUse = async (ImageName) => {
    const response = await api.put(`/invoiceFormalPromoImage/setInUse/${ImageName}`);
    return response.data;
};

export const setInvoiceFormalPromoImageNotInUse = async (ImageName) => {
    const response = await api.put(`/invoiceFormalPromoImage/setNotInUse/${ImageName}`);
    return response.data;
};


export const addInvoiceFormalPromoImage = async (photoName, imageBase64) => {
    const response = await api.post(`/invoiceFormalPromoImage/uploadInvoiceFormalPromoImage`, {
        ImageName: photoName,
        ImageBase64Content: imageBase64,
    });
    return response.data;
};


export const deleteInvoiceFormalPromoImage = async (imageName) => {
    const response = await api.delete(`/invoiceFormalPromoImage/deleteInvoiceFormalPromoImage/${imageName}`);
    return response.data;
};

